import update from 'immutability-helper';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';

import { EXISTING_FILTER_PANEL_KEY } from '@components/filter-panel/constants';
import * as commonTypes from '@store/common/types';

import * as types from './types';

export const initialRule = {
  field: '',
  op: 'eq',
  value: '',
  key: '',
  display: '',
};

export const initialState = {
  type: 'create',
  visible: false,
  activeTabKey: EXISTING_FILTER_PANEL_KEY,
  newFilterPanel: {
    rule: [[{ ...initialRule }]],
    name: '',
    category: 'CONTENT',
    subcategory: 'Asset',
    fid: 0,
    saving: false,
    isContent: false,
  },
  savedFilterPanel: {
    selectedFilters: [],
  },
  filters: [],
  categories: {},
  dimensions: [],
  defaultFilters: [],
  dataCachedAt: null, // timestamp for caching response
  initialRule: initialRule,
};

const reducerMap = Object.create(null);

reducerMap[types.ADD_AND_RULE] = (state) =>
  update(state, {
    newFilterPanel: {
      rule: { $push: [[{ ...state.initialRule }]] },
    },
  });

reducerMap[types.ADD_OR_RULE] = (state, action) => {
  const { index } = action;
  const [idx1] = index.split('-');
  return update(state, {
    newFilterPanel: {
      rule: {
        [idx1]: {
          $push: [{ ...state.initialRule }],
        },
      },
    },
  });
};

reducerMap[types.UPDATE_OR_RULE] = (state, action) => {
  const { index, payload } = action;
  const rule = cloneDeep(state.newFilterPanel.rule);
  const [idx1, idx2] = index.split('-');
  Object.assign(rule[idx1][idx2], payload);
  return update(state, {
    newFilterPanel: {
      rule: {
        [idx1]: {
          [idx2]: {
            $merge: payload,
          },
        },
      },
    },
  });
};

reducerMap[types.START_SAVING_CHANGES] = (state) =>
  update(state, {
    newFilterPanel: {
      saving: { $set: true },
    },
  });

reducerMap[types.UPDATE_CONTENT_FILTER] = (state, action) =>
  update(state, {
    newFilterPanel: {
      isContent: { $set: action.isContent },
    },
  });

reducerMap[types.DONE_SAVING_CHANGES] = (state) =>
  update(state, {
    newFilterPanel: {
      saving: {
        $set: false,
      },
    },
  });

reducerMap[types.DELETE_OR_RULE] = (state, action) => {
  const { index } = action;
  const [idx1, idx2] = index.split('-');
  const newState = update(state, {
    newFilterPanel: {
      rule: {
        [idx1]: {
          $splice: [[idx2, 1]],
        },
      },
    },
  });
  if (newState.newFilterPanel.rule[idx1].length === 0) {
    return update(newState, {
      newFilterPanel: {
        rule: {
          $splice: [[idx1, 1]],
        },
      },
    });
  }
  return newState;
};

reducerMap[types.UPDATE_ACTIVE_TAB] = (state, action) =>
  update(state, {
    activeTabKey: { $set: action.key },
  });

reducerMap[types.UPDATE_META] = (state, action) =>
  update(state, {
    $merge: {
      categories: action.categories,
      dimensions: action.dimensions,
    },
  });

reducerMap[types.DONE_GETTING_FILTERS] = (state, action) =>
  update(state, {
    $merge: {
      filters: action.filters,
      dataCachedAt: moment().format(),
    },
  });

reducerMap[types.CLEAR_FILTER_CACHE] = (state) =>
  update(state, {
    $merge: {
      // refresh in the background (current behaviour)
      // filters: [],
      dataCachedAt: null,
    },
  });

reducerMap[types.UPDATE_SELECTED_FILTERS] = (state, action) => {
  const { filters } = action;
  return update(state, {
    savedFilterPanel: {
      selectedFilters: { $set: filters },
    },
  });
};

reducerMap[types.UPDATE_FILTER_CONDITIONS] = (state, action) =>
  update(state, {
    newFilterPanel: { $merge: action.payload },
  });

reducerMap[types.CHANGE_FILTER_CONTAINER_VISIBILITY] = (state, action) => {
  const { visible } = action;
  if (visible === false) {
    return update(state, {
      $merge: {
        visible: false,
        newFilterPanel: {
          ...state.newFilterPanel,
          rule: [[{ ...state.initialRule }]],
        },
      },
    });
  }
  return update(state, {
    visible: { $set: true },
  });
};

reducerMap[commonTypes.APPLY_FILTER] = (state) =>
  update(state, {
    savedFilterPanel: {
      selectedFilters: { $set: [] },
    },
  });

reducerMap[types.SET_DEFAULT_FILTERS] = (state, action) =>
  update(state, {
    defaultFilters: {
      $set: action.filters,
    },
  });

reducerMap[types.SET_INITIAL_RULE] = (state, action) => {
  const val = state.newFilterPanel.rule[0][0]?.value;

  // initialization
  if (!val) {
    return update(state, {
      $merge: {
        initialRule: action.initialRule,
        newFilterPanel: {
          ...state.newFilterPanel,
          rule: [[{ ...action.initialRule }]],
        },
      },
    });
  } else {
    // already filtered before initialization
    return update(state, {
      $merge: {
        initialRule: action.initialRule,
      },
    });
  }
};

const filterContainer = (state = initialState, action) =>
  reducerMap[action.type] ? reducerMap[action.type](state, action) : state;

export default filterContainer;
